import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  delay = 0,
  y = 36,
  duration = 0.85,
  className = "",
  once = true,
}) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for editorial headings.
// The untransformed mask observes inView (IntersectionObserver clips
// transformed children, so observation must live on the outer wrapper).
export const MaskedLines = ({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.14,
  inView = true,
  duration = 1.0,
}) => (
  <div className={className}>
    {lines.map((line, i) => (
      <motion.div
        key={i}
        className="overflow-hidden"
        initial="hidden"
        {...(inView
          ? { whileInView: "visible", viewport: { once: true, margin: "-40px" } }
          : { animate: "visible" })}
      >
        <motion.div
          variants={{ hidden: { y: "110%" }, visible: { y: "0%" } }}
          transition={{ duration, delay: delay + i * stagger, ease: EASE }}
          className={lineClassName}
        >
          {line}
        </motion.div>
      </motion.div>
    ))}
  </div>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <Reveal y={16} duration={0.65} className={className}>
    <span
      className={`inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.32em] ${
        light ? "text-white/60" : "text-brand"
      }`}
    >
      <span
        className={`h-px w-8 ${light ? "bg-white/40" : "bg-brand/60"}`}
        aria-hidden="true"
      />
      {children}
    </span>
  </Reveal>
);
